module.exports = __webpack_public_path__ + "img/andong_gallery1.7a4a3a0e.jpg";